module.exports = __webpack_public_path__ + "static/media/School Building.6c210b8f.svg";